module.exports = __webpack_public_path__ + "img/nim-wordmark.a74048de.png";